import { ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useAuthStore } from '@/stores/auth';
import { decodeJwt } from '@/lib/jwt';

// Persistent banner shown when the JWT carries `acting_as_practice_id`.
// Anchored at the top of AppShell so every PHI-bearing screen makes it
// unmistakable that a Good Steward staffer is operating as the practice.
//
// Decodes the JWT client-side — no backend round-trip — to pick up the
// acting-as flag. Signature verification is the server's job; we just
// need the payload to drive UI.

export function ActingAsBanner() {
    const token = useAuthStore((s) => s.token);
    const practice = useAuthStore((s) => s.practice);
    const logout = useAuthStore((s) => s.logout);

    const claims = decodeJwt(token);
    if (!claims?.acting_as_practice_id) return null;

    const practiceLabel = practice?.name ?? 'this practice';

    return (
        <div
            role="status"
            aria-live="polite"
            className="bg-warning-soft border-b border-warning-border text-warning-text px-4 py-2 text-sm flex items-center gap-3"
        >
            <ShieldAlert className="w-4 h-4 shrink-0" aria-hidden />
            <span className="flex-1">
                <strong className="font-semibold">Acting as {practiceLabel}</strong>
                {' '}— Good Steward staff impersonation. All actions are audited.
            </span>
            <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => logout()}
            >
                End impersonation
            </Button>
        </div>
    );
}
